import { render, staticRenderFns } from "./sendSms.vue?vue&type=template&id=2c826c1c&scoped=true"
import script from "./sendSms.vue?vue&type=script&lang=js"
export * from "./sendSms.vue?vue&type=script&lang=js"
import style0 from "./sendSms.vue?vue&type=style&index=0&id=2c826c1c&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c826c1c",
  null
  
)

export default component.exports